import { render, staticRenderFns } from "./TaskRuleList.vue?vue&type=template&id=74b0b861"
import script from "./TaskRuleList.vue?vue&type=script&lang=js"
export * from "./TaskRuleList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74b0b861')) {
      api.createRecord('74b0b861', component.options)
    } else {
      api.reload('74b0b861', component.options)
    }
    module.hot.accept("./TaskRuleList.vue?vue&type=template&id=74b0b861", function () {
      api.rerender('74b0b861', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user-task/TaskRuleList.vue"
export default component.exports